function rateModifier(valueType: string): number {
  switch (valueType) {
    case 'mBTC':
      return 1 / 1_000;
    case 'uBTC':
      return 1 / 1_000_000;
    default:
      return 1;
  }
}

export default rateModifier;
